import { render, staticRenderFns } from "./AddParticipantsModal.vue?vue&type=template&id=59871eb0&scoped=true"
import script from "./AddParticipantsModal.vue?vue&type=script&lang=js"
export * from "./AddParticipantsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59871eb0",
  null
  
)

export default component.exports